import { render, staticRenderFns } from "./QueryDataBind.vue?vue&type=template&id=432c2108&scoped=true"
import script from "./QueryDataBind.vue?vue&type=script&lang=js"
export * from "./QueryDataBind.vue?vue&type=script&lang=js"
import style0 from "./QueryDataBind.vue?vue&type=style&index=0&id=432c2108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432c2108",
  null
  
)

export default component.exports